import { faCommentDots } from '@fortawesome/free-regular-svg-icons'
import React, { useState } from 'react'

import IconButton from '@/components/IconButton'
import Touchpoints from '@/components/Touchpoints'
import type { Application } from '@/types/Activity'
import type { Touchpoint } from '@/types/Touchpoints'

interface Props {
  application: Application
  messages: Touchpoint[]
  onPostCommentSuccess: () => void
}

const InternalComments = ({ application, messages, onPostCommentSuccess }: Props) => {
  const [internalCommentsSidebarOpen, setInternalCommentsSidebarOpen] = useState(false)

  return (
    <>
      <Touchpoints
        application={application}
        isOpen={internalCommentsSidebarOpen}
        onClose={() => setInternalCommentsSidebarOpen(false)}
        messages={messages}
        onPostCommentSuccess={onPostCommentSuccess}
      />
      <IconButton
        tooltipMessage="View internal Comments"
        icon={faCommentDots}
        onClick={() => setInternalCommentsSidebarOpen(true)}
        notificationCount={messages.length}
      />
    </>
  )
}

export default InternalComments
